import React, { useEffect, useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { saveToken, logout, getToken, getUserFromToken, isAuthenticated } from '../utils/auth';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import logo from "../assets/icon.png";
import { loginUser } from "../utils/auth";
import "./LoginPage.css";

const LoginPage = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [token, setToken] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const userName = getUserFromToken() || 'User';

  useEffect(() => {
    setToken(isAuthenticated() ? getToken() : '');
  }, []);

  const handleLogin = useCallback(async (event) => {
    event?.preventDefault();

    if (!userId || !password) {
      setError('Please enter both fields');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const response = await loginUser(userId, password);

      const data = response.data;
      if (data.token) {
        saveToken(data.token);
        setToken(data.token);
        navigate("/email-automation");
      } else {
        setError('Invalid credentials');
      }
    } catch (err) {
      console.error(err);
      setError('Login failed');
    } finally {
      setIsLoading(false);
    }
  }, [navigate, userId, password]);

  return (
    <div className="login-page pt-5  ">
      <div className="login-shell">
        <section className="login-brand-panel">
          <div className="login-brand-inner text-center">
            <div className="login-logo-badge">
              <img
                src={logo}
                alt="Civinex logo"
                className="login-logo-image"
              />
              <p className="login-eyebrow">Admin workspace</p>
            </div>
            <h1 className="login-brand-title">Civinex Dashboard</h1>
            <p className="login-brand-copy">
              Manage uploads, reports, and lead operations from one streamlined
              place with a clean and focused workflow.
            </p>
            <div className="login-brand-points">
              <div className="login-brand-point">Secure internal access for the admin team</div>
              <div className="login-brand-point">Comfortable experience across desktop and mobile</div>
              <div className="login-brand-point">Fast access to uploads, reports, and lead operations</div>
            </div>
          </div>
        </section>

        <section className="login-form-panel">
          {token ? (
            <div className="login-card login-status-card">
              <span className="login-card-badge">Session active</span>
              <h2 className="login-card-title">You are already logged in</h2>
              <p className="login-card-subtitle">
                Continue to the dashboard or log out from this device.
              </p>
              <div className="login-status-actions">
                <Link className="btn login-primary-btn" to="/email-automation">
                  Continue as {userName}
                </Link>
                <button className="btn login-secondary-btn" onClick={() => logout()}>
                  Log Out
                </button>
              </div>
            </div>
          ) : (
            <div className="login-card">
              <span className="login-card-badge">Welcome back</span>
              <h2 className="login-card-title">Sign in to continue</h2>
              <p className="login-card-subtitle">
                Use your admin credentials to access the dashboard.
              </p>

              <form onSubmit={handleLogin}>
              <div className="login-form-group">
                <label className="login-label" htmlFor="userId">
                  User ID
                </label>
                <input
                  id="userId"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter your user ID"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                />
              </div>

              <div className="login-form-group">
                <label className="login-label" htmlFor="password">
                  Password
                </label>
                <div className="login-password-field">
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    className="form-control login-input login-password-input"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    className="login-password-toggle"
                    onClick={() => setShowPassword((current) => !current)}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                    aria-pressed={showPassword}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>

              <button type="submit" disabled={isLoading} className="btn login-primary-btn login-submit-btn">
                {isLoading ? "Logging in..." : "Login"}
              </button>
              </form>

              {error && <div className="alert alert-danger login-alert">{error}</div>}
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default LoginPage;
